export type NameTranslations = Record<string, string> | null;

export const LANGUAGE_LABELS: Record<string, string> = {
  es: "Spanish (Español)",
  fr: "French (Français)",
};

export function getTranslatedValue(
  value: string,
  translations: NameTranslations | undefined,
  lang: string,
): string {
  if (lang === "en" || !translations) return value;
  return translations[lang] ?? value;
}
